export const TDL_DOMAIN="https://www.tatadigital.com"
export const NEU_DOMAIN="https://www.tataneu.com"
export const CURRENT_DOMAIN=window?.location?.origin===NEU_DOMAIN?NEU_DOMAIN:TDL_DOMAIN
export const INTERESTED_URL = `${CURRENT_DOMAIN}/finance/creditcard/product-detail?`
export const CALCULATOR_URL = `${CURRENT_DOMAIN}/v2/creditcard/savings-calculator`
export const WEBVIEW_INTERESTED_URL='https://tdl.com/goBackToNative?path=/finance/creditcard/product-detail'
export const DESKTOP_JOURNEY_URL = `${CURRENT_DOMAIN}/v2/creditcard/download`
export const QUERY_STRINGS = 'utm_source=Microsite&utm_medium=NeuCardAcq&utm_campaign=Microsite'
export const SBI_URL = `${CURRENT_DOMAIN}/v2/creditcard/sbi-cards`